import { IP } from '@model/ftf-api.model';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromItem from '../reducers/items.reducer';

export const selectItemsState = createFeatureSelector<fromItem.ItemsState>('items');

export const selectAllItems = createSelector(selectItemsState, fromItem.selectAllItems);

export const selectUserEntities = createSelector(selectItemsState, fromItem.selectItemEntities);

/**
 * Selects an item by its identifier and IP type.
 * @param identifier The identifier of the item.
 * @param ipType The IP type of the item.
 * @returns A selector function that retrieves the item.
 */
export const selectItemByIdentifierAndType = (identifier: string, ipType: IP.TrifTypeEnum) =>
  createSelector(selectUserEntities, (entities) => entities[fromItem.itemKey({ identifier, ipType })]);

/**
 * Selects an item by its serial number and IP type.
 * @param serial The serial number of the item.
 * @param ipType The IP type of the item.
 * @returns A selector function that retrieves the item.
 */
export const selectItemBySerialAndType = (serial: string, ipType: IP.TrifTypeEnum) =>
  createSelector(selectAllItems, (items) => {
    const normalizedSerial = serial.replace(/[^a-z0-9]/gi, '').toLowerCase();
    return items.find(
      (item) => item.serial && item.serial.replace(/[^a-z0-9]/gi, '').toLowerCase() === normalizedSerial && item.ipType === ipType
    );
  });

export const selectItemsError = createSelector(selectItemsState, fromItem.selectItemsError);
